/*
 * @Description: 多语言配置
 * @Author: pliybird
 * @Date: 2023-05-12 10:27:40
 * @LastEditTime: 2023-07-18 17:32:47
 * @LastEditors: pliybird
 * @filePath: Do not edit
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n) // 全局注册国际化包
import zh_CN from './zh_CN'
import en_US from './en_US'
import ja_JP from './ja_JP'

// let language = window.sessionStorage.getItem('lang')
const i18n = new VueI18n({
    locale:'zh_CN',
    fallbackLocale:'zh_CN',
    messages:{
        // 英文数据
        en_US:en_US,
        // 中文数据
        zh_CN:zh_CN,
        // 日语数据
        ja_JP:ja_JP
    }
})
// locale.i18n((key, value) => i18n.t(key, value))
 
export default i18n